class StoreAvailabilityModule extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      addToCartController: '[js-add-to-cart-controller]',
      notifyMeController: '[js-notify-me-controller]',
      product: '.product',
      pickupAvailability: '[js-product-pickup-availability]',
      image: '[js-pickup-image]',
      variantOption: '[js-product-option-selector]',
      price: '[js-price]',
      list: '[js-store-list]',
      store: '[js-pickup-store]',
      distance: '[js-distance]',
      variantSelects: 'variant-radios'
    };
  }

  connectedCallback() {
    this.product = document.querySelector(this._selectors.product);
    this.pickupAvailability = this.querySelector(this._selectors.pickupAvailability);
    this.images = this.querySelectorAll(this._selectors.image);
    this.price = this.querySelector(this._selectors.price);
    this.variantOptions = this.querySelectorAll(this._selectors.variantOption);
    this.addToCartController = this.querySelector(this._selectors.addToCartController);
    this.notifyMeController = this.querySelector(this._selectors.notifyMeController);
    this.variantSelects = document.querySelector(this._selectors.variantSelects);

    this.userLat = null;
    this.userLong = null;
    
    this._initGeo();
    this._updatePickupAvailability(this.dataset.variantId);
    this._setListeners();
  }

  _setListeners() {
    this.variantOptions.forEach(option => {
      option.addEventListener('change', this._syncVariantChange);
    });
    this.addToCartController.addEventListener('click', this._syncAddToCart);
    this.notifyMeController.addEventListener('click', this._syncNotifyMe);
    this.variantSelects.addEventListener('change', this.onVariantChange);
  }

  _syncVariantChange = (evt) => {
    const target = evt.currentTarget;
    const variantId = target.dataset.target;
    const variantInput = this.product.querySelector(`#${variantId}`);
    const clickEvent = new MouseEvent('click', {button: 0, which: 1});
    
    variantInput.dispatchEvent(clickEvent)
  }

  _syncAddToCart = (evt) => {
    document.querySelector('[js-add-to-cart]').click();
    document.querySelector('store-availability-drawer').close();
  }

  _syncNotifyMe = (evt) => {
    document.querySelector('.klaviyo-bis-trigger').click();
  }

  _initPickupVariables() {
    this.list = this.querySelector(this._selectors.list);
    this.stores = this.querySelectorAll(this._selectors.store);
    this.distances = this.querySelectorAll(this._selectors.distance);
  }

  _revealList() {
    if (this.list) this.list.classList.remove('hidden')
  }

  _calculateDistance = (lat1, lon1, lat2, lon2) => {
    // Return 0 if same coordinates
    if ((lat1 == lat2) && (lon1 == lon2)) {
      return 0;
    }
    else {
      // Convert latitude values from degrees to radians
      var radLat1 = Math.PI * lat1/180;
      var radLat2 = Math.PI * lat2/180;

      // Calculate the difference in longitudes and convert to radians
      var theta = lon1-lon2;
      var radTheta = Math.PI * theta/180;

      // Calculate the distance using the Haversine formula
      var dist = Math.sin(radLat1) * Math.sin(radLat2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.cos(radTheta);

      // Correct any slight rounding errors that might cause dist to be greater than 1
      if (dist > 1) {
        dist = 1;
      }

      // Convert the angle from radians to degrees, then from degrees to miles
      dist = Math.acos(dist);
      dist = dist * 180/Math.PI;
      dist = dist * 60 * 1.1515;

      return dist;
    }
  }

  _renderDistance(userLat, userLong) {
    this.distances.forEach(distance => {
      const lat = Number(distance.getAttribute('data-lat'));
      const lon = Number(distance.getAttribute('data-lon'));
      const calculatedDistance = this._calculateDistance(userLat, userLong, lat, lon);
      const formattedDistance = calculatedDistance.toFixed(1)
      distance.setAttribute('data-distance', formattedDistance)
      distance.textContent = formattedDistance + " mi"
      distance.classList.remove('hidden');
    })
  }

  _reorderList() {
    const storeArray = Array.from(this.stores);

    storeArray.sort((a, b) => {
      const aDistance = Number(a.querySelector(this._selectors.distance).dataset.distance);
      const bDistance = Number(b.querySelector(this._selectors.distance).dataset.distance);
      return aDistance - bDistance;
    })

    storeArray.forEach(store => {
      this.list.appendChild(store)
    })
  }

  _initGeo = () => {
    navigator.permissions.query({ name: 'geolocation' }).then((result) => {
      if (result.state !== 'denied') {
        GeolizrAPI.addEventListener('geolizr.geoData', geoData => {
          this.userLat = geoData.lat;
          this.userLong = geoData.lon;
        });
      }
    })
  }

  _updatePickupAvailability(variantId) {
    console.log('>>> Init Pickup Module <<<');
    fetch(`https://purple-brand.com/variants/${variantId}/?section_id=pickup-availability`)
      .then((response) => response.text())
      .then((text) => {
        const pickupAvailabilityHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('.shopify-section');
        this.pickupAvailability.innerHTML = '';

        if (pickupAvailabilityHTML.querySelector('.pickup-availability-container')) {
          this.pickupAvailability.innerHTML = pickupAvailabilityHTML.innerHTML;
          this._initPickupVariables();
          if (this.userLat && this.userLong) {
            this._renderDistance(this.userLat, this.userLong);
            this._reorderList();
          }
          this._revealList();
        } else {
          this.pickupAvailability.innerHTML = '<div class="pickup-availability__error">No stores have this item in stock.</div>';
        }
      })
      .catch((e) => {
        console.error(e);
        this.pickupAvailability.innerHTML = '<div class="pickup-availability__error">There was an issue loading pickup availability, or no stores have this item in stock.</div>';
      });
  }

  _updateaddToCartControllerState(variant) {
    if (variant.available == true) {
      this.addToCartController.disabled = false;
      this.addToCartController.querySelector('span').innerHTML = 'Add to Bag';
      if (document.querySelector('.klaviyo-bis-trigger')) {
        this.addToCartController.classList.remove('hidden');
        this.notifyMeController.classList.add('hidden');
      }
    } else {
      this.addToCartController.disabled = true;
      this.addToCartController.querySelector('span').innerHTML = 'Sold Out';
      if (document.querySelector('.klaviyo-bis-trigger')) {
        this.addToCartController.classList.add('hidden');
        this.notifyMeController.classList.remove('hidden');
      }
    }
  }

  onVariantChange = (evt) => {
    const variant = evt.currentTarget.currentVariant;
    this._updatePickupAvailability(variant.id);
    this._updateaddToCartControllerState(variant);
  }
};

customElements.define('store-availability-module', StoreAvailabilityModule);